<template>
  <div id="app">
    <Header />
    <router-view />
    <Footer />
    <TabBar v-if="isLoggedIn" />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import TabBar from './components/TabBar.vue'
import userStore from './store/user.js'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    TabBar
  },
  data() {
    return {
      userStore: userStore.state
    }
  },
  computed: {
    isLoggedIn() {
      return this.userStore.isLoggedIn
    }
  },
  watch: {
    isLoggedIn(newVal) {
      if (newVal) {
        document.body.classList.add('logged-in')
      } else {
        document.body.classList.remove('logged-in')
      }
    }
  },
  mounted() {
    // 初始化时检查登录状态
    if (this.isLoggedIn) {
      document.body.classList.add('logged-in')
    }
  }
}
</script>

<style>
html {
  overflow-x: hidden !important;
  width: 100% !important;
  max-width: 100% !important;
}

body {
  overflow-x: hidden !important;
  width: 100% !important;
  max-width: 100% !important;
  
}

#app {
  overflow-x: hidden !important;
  width: 100% !important;
  max-width: 100% !important;
  background-color: #F7F7F7 !important;
}

* {
  box-sizing: border-box;
}

/* 移动端登录后添加底部内边距,避免被 TabBar 遮挡 */
@media (max-width: 767px) {
  body.logged-in #app {
    padding-bottom: 70px;
  }
}
</style>
